var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMachineLearning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9C16C8",
    d: "M6 12V6h6v6H6Zm0 6v-2H4c-.55 0-1.02-.196-1.413-.588A1.926 1.926 0 0 1 2 14v-2H0v-2h2V8H0V6h2V4c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 4 2h2V0h2v2h2V0h2v2h2c.55 0 1.02.196 1.412.587C15.804 2.98 16 3.45 16 4v2h2v2h-2v2h2v2h-2v2c0 .55-.196 1.02-.588 1.412A1.926 1.926 0 0 1 14 16h-2v2h-2v-2H8v2H6Zm8-4V4H4v10h10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineLearning);
export default __webpack_public_path__ + "static/media/machine-learning.35f513f89e4b939478fe16af9597e08f.svg";
export { ForwardRef as ReactComponent };